import Vue from 'vue'
import Router from 'vue-router'
import CBT from './views/CBT.vue'
import Roles from './views/Roles.vue'
import Users from './views/Users.vue'
import Login from './views/Login.vue'
import Email from './views/Email.vue'
import Video from './views/Video.vue'
import Stages from './views/Stages.vue'
import Opening from './views/Opening.vue'
import ScoreCard from './views/ScoreCard.vue'
import Evaluation from './views/Evaluation.vue'
import Dashboard from './views/Dashboard.vue'
import AddOpening from './views/AddOpening.vue'
import HiringNote from './views/HiringNote.vue'
import AllOpenings from './views/AllOpenings.vue'
import Application from './views/Application.vue'
import UserSummary from './views/UserSummary.vue'
import AllScoreCards from './views/AllScoreCards.vue'
import SharedResumes from './views/SharedResumes.vue'
import SearchResults from './views/SearchResults.vue'
import OfferTemplates from './views/OfferTemplates.vue'
import EditOfferTemplate from './views/EditOfferTemplate.vue'
import PreviewEvaluation from './views/PreviewEvaluation.vue'
import AllPreviewEvaluation from './views/AllPreviewEvaluation.vue'
import RecentApplications from './views/RecentApplications.vue'
import StarredApplications from './views/StarredApplications.vue'
import CreateOfferTemplate from './views/CreateOfferTemplate.vue'
import RecruitmentDashboard from './views/RecruitmentDashboard.vue'
import SingleOpeningApplicants from './views/SingleOpeningApplicants.vue'
import DiscontinuedApplications from './views/DiscontinuedApplications.vue'
import EditOpening from './views/EditOpening.vue'


Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/recruitmentdashboard',
            name: 'RecruitmentDashboard',
            component: RecruitmentDashboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/opening',
            redirect: '/openings',
        },
        {
            path: "*",
            redirect: '/dashboard'
        },
        {
            path: '/openings',
            name: 'AllOpenings',
            component: AllOpenings,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/opening/:id',
            name: 'SingleOpeningApplicants',
            component: SingleOpeningApplicants,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/opening/:id/application/:applicant_id',
            name: 'Application',
            component: Application,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/openings/new',
            name: 'AddOpening',
            component: AddOpening,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/stages',
            name: 'Stages',
            component: Stages,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/cbt/:id?',
            name: 'CBT',
            component: CBT,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/video',
            name: 'Video',
            component: Video,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/applications/starred',
            name: 'StarredApplications',
            component: StarredApplications,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/applications/discontinued',
            name: 'DiscontinuedApplications',
            component: DiscontinuedApplications,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/hiringnote/:action/:id',
            name: 'HiringNote',
            component: HiringNote,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/sharedresumes',
            name: 'SharedResumes',
            component: SharedResumes,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/offertemplates',
            name: 'OfferTemplates',
            component: OfferTemplates,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/editoffertemplate/:id',
            name: 'EditOfferTemplate',
            component: EditOfferTemplate,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/createoffertemplate/:id?',
            name: 'CreateOfferTemplate',
            component: CreateOfferTemplate,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/email',
            name: 'Email',
            component: Email,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/viewopening/:id',
            name: 'Opening',
            component: Opening,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/opening/edit/:id',
            name: 'EditOpening',
            component: EditOpening,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/scorecard/:id?',
            name: 'ScoreCard',
            component: ScoreCard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/allscorecards/:id',
            name: 'AllScoreCards',
            component: AllScoreCards,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/previewevaluation/:id',
            name: 'PreviewEvaluation',
            component: PreviewEvaluation,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/evaluation/:id?',
            name: 'Evaluation',
            component: Evaluation,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/allpreviewevaluation/:id',
            name: 'AllPreviewEvaluation',
            component: AllPreviewEvaluation,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/recentapplications/:id',
            name: 'RecentApplications',
            component: RecentApplications,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/searchresults',
            name: 'SearchResults',
            component: SearchResults,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/usersummary/:id',
            name: 'UserSummary',
            component: UserSummary,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/users',
            name: 'Users',
            component: Users,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/roles',
            name: 'Roles',
            component: Roles,
            meta: {
                requiresAuth: true
            }
        },
    ]
})
